import React from 'react';
import { Droppable, DroppableProvided } from 'react-beautiful-dnd';

type Props = {
  droppableId: string;
  type?: string;
  children: (placeholder: DroppableProvided['placeholder']) => React.ReactNode;
  className?: string;
};

export const DroppableContainer = ({ droppableId, type, children, className }: Props) => {
  return (
    <Droppable droppableId={droppableId} type={type}>
      {provided => {
        return (
          <div {...provided.droppableProps} className={className} ref={provided.innerRef}>
            {children(provided.placeholder)}
          </div>
        );
      }}
    </Droppable>
  );
};
